// extracted by mini-css-extract-plugin
export default {"panelSearchControl":"RGTY","searchOptions":"xgnk"};